import { PusherClient } from '@getaccept/pusher';
import { getPrefixedInternalApiBaseUrl } from '../helpers/get-prefixed-api-base-url';
import { UrlHelper } from '../helpers/url.helper';

const getPusherUrl = () => {
  if (!import.meta.env.VUE_APP_INTERNAL_API_BASE_URL) {
    throw new Error('VUE_APP_INTERNAL_API_BASE_URL is not set in .env file');
  }
  return UrlHelper.getHttpsUrl(
    getPrefixedInternalApiBaseUrl(
      import.meta.env.VUE_APP_INTERNAL_API_BASE_URL,
      window.location.hostname
    )
  );
};

export const pusherClientInternal = new PusherClient(getPusherUrl());
